<template>
  <div class="jobs-list">
    <div class="controls-container">
      <router-link to="/dashboard/inch/create">
        <el-button type="primary">
          Добавить дюйм
        </el-button>
      </router-link>
    </div>
    <template>
      <div
        class="jobs-ul"
      >
        <div
          class="jobs-li" v-for="(t, index) in tableData" :key="index"
        >
          <div class="name handle">
            <span>{{ t.dia }}x{{ t.width }} - <strong>{{ t.inch }}</strong></span>
          </div>
          <div @click="toEdit(t)">

            <i class="fa fa-edit"></i>
          </div>
        </div>
      </div>
      <!--      <el-table-->
      <!--        :row-class-name="tableRowClassName"-->
      <!--        :data="tableData"-->
      <!--        border-->
      <!--        style="width: 100%">-->
      <!--        <el-table-column-->
      <!--          prop="id"-->
      <!--          label=""-->
      <!--          width="70">-->
      <!--        </el-table-column>-->
      <!--        <el-table-column-->
      <!--          :key="i"-->
      <!--          v-for="i in 29"-->
      <!--          :prop="`${i + 1}`"-->
      <!--          :label="`${i + 1}`"-->
      <!--          width="50">-->
      <!--        </el-table-column>-->
      <!--        <el-table-column-->
      <!--          fixed="right"-->
      <!--          label=""-->
      <!--          width="110">-->
      <!--          <template slot-scope="scope">-->
      <!--            <div v-if="scope.row.link_id">-->
      <!--              <router-link-->
      <!--                :to="`/dashboard/inch/${scope.row.link_id}/edit`"-->
      <!--                type="text"-->
      <!--                size="small"-->
      <!--              >-->
      <!--                <el-button type="text" size="small">Редактировать</el-button>-->
      <!--              </router-link>-->
      <!--            </div>-->
      <!--          </template>-->
      <!--        </el-table-column>-->
      <!--      </el-table>-->
    </template>

  </div>
</template>

<script>
import draggable from 'vuedraggable';
import {getInches} from "../../../firestore/inch";

export default {
  name: 'List',
  components: {draggable},

  data() {
    return {
      tableData: [],
    };
  },

  async mounted() {

    this.tableData = await getInches(this.$store.state.project.id);

    // console.log(result, ' result');
    //
    // console.log(await getInches(this.$store.state.project.id), 'getInches')
    //
    // firebase.firestore()
    //   .collection('projects')
    //   .doc(this.$store.state.project.id)
    //   .collection('inch').get().then((response) => {
    //   const result = [];
    //   response.forEach((subDoc) => {
    //     result.push({
    //       ...subDoc.data(),
    //       link_id: subDoc.id
    //     });
    //   });
    //   const tableData = [...result.reverse(), ...this.tableData];
    //   this.tableData = tableData.map((tb) => {
    //     console.log(tb, 'tb')
    //   })
    // });
  },
  methods: {
    tableRowClassName({row, rowIndex}) {
      if (row.link_id) {
        return 'success-row';
      }
      return '';
    },
    toEdit(t) {
      this.$router.push({
        path: '/dashboard/inch/' + (t.id || 'new') + '/edit',
        query: {
          width: t.width,
          dia: t.dia,
          inch: t.inch
        }
      })
    }
  }
};
</script>

<style>
.el-table .success-row {
  background: #f0f9eb;
}
</style>
<style scoped lang="scss">

.jobs-list {
  max-width: 382px;
  width: calc(100% - 40px);
  margin: 22px auto;
}

.controls-container {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  flex: 1;
  margin-bottom: 12px;
}


.jobs-ul {
  display: flex;
  flex-direction: column;
  margin-top: 10px;

  .jobs-li {
    align-items: center;
    display: flex;
    justify-content: space-between;
    min-height: 36px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);
    cursor: pointer;
    padding: 4px 12px;

    color: #000;
    text-decoration: none !important;

    span {
      text-align: left;
    }

    &:hover {
      background: #f0f0f0;
    }

    &:last-child {
      border-bottom: none;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Join/Index.vue